<template>
	<div class="div-erro">
		<div class="container box-msg">
			<i>
				<font-awesome-icon :icon="icon" />
			</i>
			<p :key="mensagem" v-html="mensagem"></p>
			<!-- <a href="http://www.econeteditora.com.br" >Clique aqui</a> para voltar ao site da Econet -->
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				mensagem: "",
				icon: ""
			};
		},
		mounted() {
			switch (parseInt(this.$route.params.intErro)) {
        case 405:
          this.icon = "hand-paper";
          this.mensagem =
						"Acesso não autorizado! <br /> Identificado acessos simultâneos.<br /> Aguarde um instante e tente novamente!";
          break;
				case 404:
					this.icon = "exclamation-triangle";
					this.mensagem =
						"Caminho não encontrado! <br /> Por favor verifique a url.";
					break;
				case 403:
					this.icon = "hand-paper";
					this.mensagem =
						"Acesso não autorizado! <br /> Por favor logue pelo site <br /> <a href='http://www.econeteditora.com.br/'>Econet Editora Empresarial</a>.";
          break;

				case 401:
					this.icon = "heartbeat";
					this.mensagem =
						"Token Inválido! <br /> Por favor logue novamente no sistema.";
					break;
				default:
					this.icon = "key";
					this.mensagem = "Erro inesperado! <br /> Por favor tente novamente.";
					break;
			}
		},
		methods: {}
	};
</script>
